/* eslint-disable no-param-reassign */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable no-await-in-loop */
import React, { memo, useEffect, useLayoutEffect, useState } from 'react';
import {
  Button,
  Card,
  Checkbox,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  InputNumber,
  List,
  message,
  Popconfirm,
  Row,
  Select,
  Tabs,
  TimePicker,
  Upload,
} from 'antd';
import Inputmask from 'inputmask';
import moment from 'moment';
import { useNavigate, useParams } from 'react-router-dom';

import { CloseOutlined, PlusOutlined, UploadOutlined } from '@ant-design/icons';

import CompanyFunctions from '../../../Assets/Scripts/CompanyFunctions';
import Utils from '../../../Assets/Scripts/Utils';
import {
  applyRegisterCustomFields,
  createRegisterShowField,
  RegisterLayoutBody,
  useRegisterFieldLayout,
} from '../../../Components/ResourceFieldLayout/RegisterFieldLayout';
import { api } from '../../../Services/axiosService';

import TrainingCenterFunctions from './TrainingCenterFunctions';
import { isResourceQtyOverCap, maxSlotsForColumns } from './trainingCenterResourceQty';

import './TrainingCenterRegister.scss';

const { Search } = Input;

const workDaysOptions = [
  { label: 'Selecionar todos', value: 'selectAll' },
  { label: 'Segunda', value: '1' },
  { label: 'Terça', value: '2' },
  { label: 'Quarta', value: '3' },
  { label: 'Quinta', value: '4' },
  { label: 'Sexta', value: '5' },
  { label: 'Sábado', value: '6' },
  { label: 'Domingo', value: '0' },
];

let canHandleCT = false;
let isInactive = false;

const SLOTS_OVER_CAP_MESSAGE = 'Qtd. Slots não pode ultrapassar Qtd. Colunas × 5.';

const minZeroQtyRule = {
  validator(_, value) {
    if (value == null || value >= 0) {
      return Promise.resolve();
    }

    return Promise.reject(new Error('Valor mínimo é 0.'));
  },
};

function TrainingCenterRegisterComponent() {
  const { id: editId } = useParams();
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const [loading, setLoading] = useState(false);
  const [fieldsPermissions, setFieldsPermissions] = useState();
  const { fieldLayout, roleId } = useRegisterFieldLayout('TrainingCenter');
  const showField = createRegisterShowField(fieldsPermissions, fieldLayout, roleId);
  const [documentTypeOptions, setDocumentTypeOptions] = useState();
  const [trainingsOptions, setTrainingsOptions] = useState();
  const [screenModified, setScreenModified] = useState(false);
  const [bitrixAddresses, setBitrixAddresses] = useState([]);
  const [requiredDocuments, setRequiredDocuments] = useState();
  const [cnpjApiConfig, setCnpjApiConfig] = useState();

  const [ctMaxSlots, setCtMaxSlots] = useState(0);
  const [inCompanyMaxSlots, setInCompanyMaxSlots] = useState(0);
  const [eadMaxSlots, setEadMaxSlots] = useState(0);
  const [serviceMaxSlots, setServiceMaxSlots] = useState(0);

  const markResourceQtyModified = () => {
    setScreenModified(true);
  };

  const onResourceColumnsChange = (setMaxSlots) => (columnQty) => {
    markResourceQtyModified();
    setMaxSlots(maxSlotsForColumns(columnQty));
  };

  const createSlotsCapRule = (columnsFieldName) => ({
    validator(_, slotsValue) {
      const columns = form.getFieldValue(columnsFieldName);
      if (!isResourceQtyOverCap(slotsValue, columns)) {
        return Promise.resolve();
      }

      return Promise.reject(new Error(SLOTS_OVER_CAP_MESSAGE));
    },
  });

  const fetchTrainingCenterById = async (editId) => {
    setLoading(true);

    const response = await api
      .get(`/TrainingCenter?id=${editId}`)
      .then((res) => res.data)
      .catch((error) => {
        Utils.logError(error);
        message.error('Oops. Algo deu errado ao buscar os dados do centro de treinamento!');
      });

    response.workDays = response.workDays?.split(',');
    response.businessHour = [moment(response.startBusinessHour), moment(response.endBusinessHour)];
    response.breakTime = [moment(response.breakStart), moment(response.breakFinish)];
    response.trainingKind = response?.trainingKind?.map(({ id }) => id);
    response.tracksKind = response?.tracksKind?.map(({ id }) => id);
    response.documents = response?.documents?.map(
      ({ type: { id: type }, number, validity, downloadUrls, verified }) => ({
        type,
        number,
        validity: moment(validity),
        downloadUrls,
        verified,
      })
    );

    setCtMaxSlots(maxSlotsForColumns(response.ctQtyColumns));
    setInCompanyMaxSlots(maxSlotsForColumns(response.inCompanyQtyColumns));
    setEadMaxSlots(maxSlotsForColumns(response.eadQtyColumns));
    setServiceMaxSlots(maxSlotsForColumns(response.serviceQtyColumns));

    isInactive = response.status === 'Inativo';

    form.setFieldsValue(applyRegisterCustomFields(response));
    setLoading(false);
  };

  const submit = async (values) => {
    setLoading(true);
    const data = { ...values };

    if (values.businessHour && values.businessHour !== undefined) {
      data.startBusinessHour = moment.utc(values.businessHour[0]).format('YYYY-MM-DDTHH:mm:ss');
      data.endBusinessHour = moment.utc(values.businessHour[1]).format('YYYY-MM-DDTHH:mm:ss');
    }
    if (values.breakTime && values.breakTime !== undefined) {
      data.breakStart = moment.utc(values.breakTime[0]).format('YYYY-MM-DDTHH:mm:ss');
      data.breakFinish = moment.utc(values.breakTime[1]).format('YYYY-MM-DDTHH:mm:ss');
    }

    data.workDays = data.workDays?.toString();
    data.tracksKind = data.tracksKind?.map((type) => {
      const [training] = trainingsOptions?.filter(({ value: id }) => id === type);

      return {
        id: training.value,
        name: training.label,
      };
    });

    data.trainingKind = data.trainingKind?.map((type) => {
      const [training] = trainingsOptions?.filter(({ value: id }) => id === type);

      return {
        id: training.value,
        name: training.label,
      };
    });

    await CompanyFunctions.saveDocuments(data, 'trainingCenter');

    const httpMethod = editId ? 'put' : 'post';
    await api[httpMethod]('/TrainingCenter', data)
      .then(() => {
        message.success(`Dados ${editId ? 'atualizados' : 'salvos'}!`);
        form.resetFields();

        if (editId) {
          fetchTrainingCenterById(editId);
        }

        setLoading(false);
        setScreenModified(false);
      })
      .catch((error) => {
        Utils.logError(error);
        message.error('Oops. Erro ao enviar os dados do centro de treinamento!');
        setLoading(false);
      });
  };

  const fetchTrainings = async () => {
    const trainings = await api
      .get('/Trainings')
      .then((res) => res.data)
      .catch((error) => {
        Utils.logError(error);
        message.error('Oops. Algo deu errado ao buscar os grupos de treinamento!');
      });

    const mappedTrainings = trainings?.map(({ id: value, name: label }) => ({
      label,
      value,
    }));

    mappedTrainings?.unshift({ value: 'selectAll', label: 'Selecionar todos' });
    setTrainingsOptions(mappedTrainings);
  };

  const fetchDocumentTypes = async () => {
    const documentTypes = await api
      .get(
        '/DocumentType?filters[0].Field=Status&filters[0].Condition=DIFFERENT&filters[0].Value=Inativo'
      )
      .then((res) => res.data)
      .catch((error) => {
        Utils.logError(error);
        message.error('Oops. Algo deu errado ao buscar os tipos de documento!');
      });

    const mappedDocumentTypes = documentTypes?.map(({ id: value, name: label }) => ({
      label,
      value,
    }));

    setDocumentTypeOptions(mappedDocumentTypes);
    return mappedDocumentTypes;
  };

  const fetchSettingsAndAddressess = async () => {
    const docTypes = await fetchDocumentTypes();

    const res = await api
      .get(`/Settings?id=1`)
      .then(async (res) => {
        const decryptedResponse = Utils.decryptSettings(res.data);
        TrainingCenterFunctions.fetchBitrixAddresses(
          decryptedResponse?.bitrixWebhookUrl,
          setBitrixAddresses
        );
        return decryptedResponse;
      })
      .catch((error) => {
        Utils.logError(error);
        message.error('Oops. Algo deu errado ao buscar os endereços do bitrix!');
      });

    setCnpjApiConfig({
      url: res.cnpjApiUrl,
      token: res.cnpjApiToken,
    });

    const reqDocsIds = res.requiredDocumentsCT?.split(',')?.map((item) => parseInt(item, 10)) ?? [];

    const reqDocs = docTypes
      ?.filter(({ value }) => reqDocsIds.includes(value))
      ?.map(({ label }) => label);

    setRequiredDocuments(reqDocs);
  };

  useLayoutEffect(() => {
    const permissions = {};
    JSON.parse(localStorage.getItem('conecta__permissions'))?.resources.forEach(
      ({ name, fields, canHandle }) => {
        if (name === 'TrainingCenter') {
          canHandleCT = canHandle;
          fields.forEach(({ name, access, isRequired }) => {
            permissions[name] = { access, isRequired };
          });
        }
      }
    );
    setFieldsPermissions(permissions);
  }, []);

  useEffect(() => {
    fetchTrainings();
    fetchSettingsAndAddressess();

    Inputmask({ mask: '(99) 9{1,9}' }).mask(document.getElementById('phone2'));
    Inputmask({ mask: '(99) 9{1,9}' }).mask(document.getElementById('phone1'));
    Inputmask({ mask: '99999-999' }).mask(document.getElementById('cep'));
    Inputmask({ mask: '99.999.999/9999-99' }).mask(document.getElementById('cnpj'));

    if (editId) {
      fetchTrainingCenterById(editId);
    }
  }, []);

  const extraTabPanes = () => [
    <Tabs.TabPane tab="Documentos" key="documentsData" forceRender>
      <Form.List name="documents">
        {(fields, { add, remove }) => (
          <>
            {requiredDocuments?.length > 0 && (
              <div>
                <h3>Documentos Obrigatórios</h3>
                <p style={{ margin: 0 }}>{requiredDocuments?.join(' / ')}</p>
              </div>
            )}

            <Button
              style={{
                marginBottom: 15,
                width: 200,
              }}
              type="dashed"
              onClick={() => {
                add();
                setScreenModified(true);
              }}
              block
              icon={<PlusOutlined />}
            >
              Adicionar Documento
            </Button>

            <Row gutter={[24]}>
              {fields.map(({ key, name, ...restField }) => (
                <Col key={key} span={8}>
                  <Card
                    extra={
                      <Popconfirm
                        title="Deseja mesmo excluir?"
                        onConfirm={() => {
                          if (form.getFieldValue('documents')[name]?.downloadUrls) {
                            CompanyFunctions.deleteDocumentFromStorage(
                              form,
                              'trainingCenter',
                              name
                            );
                            remove(name);
                            submit(form.getFieldsValue());
                            setScreenModified(false);
                          } else {
                            remove(name);
                            setScreenModified(true);
                          }
                        }}
                        okText="Sim"
                        cancelText="Não"
                      >
                        <CloseOutlined />
                      </Popconfirm>
                    }
                    style={{
                      backgroundColor: '#ffffff00',
                      borderColor: '#b7b7b7',
                      borderRadius: 16,
                      marginBottom: 10,
                    }}
                  >
                    {canHandleCT && (
                      <Col span={24}>
                        <Form.Item
                          {...restField}
                          name={[name, 'verified']}
                          valuePropName="checked"
                          initialValue={true}
                        >
                          <Checkbox>Verificado</Checkbox>
                        </Form.Item>
                      </Col>
                    )}
                    {showField('DocumentType') && (
                      <Col span={24}>
                        <Form.Item
                          {...restField}
                          name={[name, 'type']}
                          label="Tipo de documento"
                          rules={[
                            {
                              required: fieldsPermissions?.DocumentType.isRequired,
                              message: 'Campo obrigatório!',
                            },
                          ]}
                          getValueFromEvent={(_, object) => {
                            if (!object) return null;

                            return {
                              ...object,
                              name: object.label,
                              id: object.value,
                            };
                          }}
                        >
                          <Select
                            options={documentTypeOptions}
                            allowClear
                            placeholder="Selecione"
                            optionFilterProp="label"
                            showSearch
                            dropdownStyle={{ borderRadius: 16 }}
                            disabled={fieldsPermissions?.DocumentType.access !== 2 || isInactive}
                          />
                        </Form.Item>
                      </Col>
                    )}
                    {showField('DocumentNumber') && (
                      <Col span={24}>
                        <Form.Item
                          {...restField}
                          name={[name, 'number']}
                          label="Nº documento"
                          rules={[
                            {
                              required: fieldsPermissions?.DocumentNumber.isRequired,
                              message: 'Campo obrigatório!',
                            },
                          ]}
                        >
                          <Input
                            disabled={fieldsPermissions?.DocumentNumber.access !== 2 || isInactive}
                          />
                        </Form.Item>
                      </Col>
                    )}
                    {showField('DocumentValidity') && (
                      <Col span={24}>
                        <Form.Item
                          {...restField}
                          name={[name, 'validity']}
                          label="Validade"
                          rules={[
                            {
                              required: fieldsPermissions?.DocumentValidity.isRequired,
                              message: 'Campo obrigatório!',
                            },
                          ]}
                        >
                          <DatePicker
                            format="DD-MM-YYYY"
                            style={{
                              borderRadius: 16,
                            }}
                            disabled={
                              fieldsPermissions?.DocumentValidity.access !== 2 || isInactive
                            }
                          />
                        </Form.Item>
                      </Col>
                    )}

                    {showField('UploadFiles') &&
                      form.getFieldValue('documents')[name]?.downloadUrls && (
                        <Col span={24}>
                          <Form.Item
                            {...restField}
                            name={[name, 'downloadUrls']}
                            label
                            style={{
                              textAlign: 'center',
                            }}
                            rules={[
                              {
                                required: fieldsPermissions?.UploadFiles.isRequired,
                                message: 'Campo obrigatório!',
                              },
                            ]}
                          >
                            <List
                              size="small"
                              header={<div>Arquivos</div>}
                              bordered
                              dataSource={form.getFieldValue('documents')[name]?.downloadUrls}
                              renderItem={({ label, url }) => (
                                <List.Item>
                                  <a href={url} target="blank" style={{ wordBreak: 'break-word' }}>
                                    {label}
                                  </a>
                                </List.Item>
                              )}
                            />
                          </Form.Item>
                        </Col>
                      )}

                    {showField('UploadFiles') &&
                      !form.getFieldValue('documents')[name]?.downloadUrls && (
                        <Col span={24}>
                          <Form.Item
                            {...restField}
                            name={[name, 'uploadFiles']}
                            label
                            style={{
                              textAlign: 'center',
                            }}
                            rules={[
                              {
                                required: fieldsPermissions?.UploadFiles.isRequired,
                                message: 'Campo obrigatório!',
                              },
                            ]}
                          >
                            <Upload
                              multiple
                              beforeUpload={() => false}
                              disabled={fieldsPermissions?.UploadFiles.access !== 2 || isInactive}
                            >
                              <Button icon={<UploadOutlined />}>Upload de arquivos</Button>
                            </Upload>
                          </Form.Item>
                        </Col>
                      )}
                  </Card>
                </Col>
              ))}
            </Row>
          </>
        )}
      </Form.List>
    </Tabs.TabPane>,
  ];

  const widgetMap = {
    Cnpj: () =>
      showField('Cnpj') && (
        <Col span={8}>
          <Form.Item
            label="CNPJ"
            name="cnpj"
            rules={[
              {
                required: fieldsPermissions?.Cnpj.isRequired,
                validator: (rule, value) => {
                  const isValid = Utils.validateCNPJ(value);
                  if (!isValid && fieldsPermissions?.Cnpj.isRequired) {
                    return Promise.reject(new Error(`CNPJ Inválido`));
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            <Search
              id="cnpj"
              placeholder="00.000.000/0000-00"
              disabled={fieldsPermissions?.Cnpj.access !== 2 || isInactive}
              onSearch={(val) => CompanyFunctions.fetchCnpj(val, form, cnpjApiConfig)}
            />
          </Form.Item>
        </Col>
      ),
    Name: () =>
      showField('Name') && (
        <Col span={8}>
          <Form.Item
            label="Nome"
            name="name"
            rules={[
              {
                required: fieldsPermissions?.Name.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input disabled={fieldsPermissions?.Name.access !== 2 || isInactive} />
          </Form.Item>
        </Col>
      ),
    CommercialName: () =>
      showField('CommercialName') && (
        <Col span={8}>
          <Form.Item
            label="Nome Fantasia"
            name="commercialName"
            rules={[
              {
                required: fieldsPermissions?.CommercialName.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input disabled={fieldsPermissions?.CommercialName.access !== 2 || isInactive} />
          </Form.Item>
        </Col>
      ),
    Street: () =>
      showField('Street') && (
        <Col span={7}>
          <Form.Item
            label="Rua"
            name="street"
            rules={[
              {
                required: fieldsPermissions?.Street.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input disabled={fieldsPermissions?.Street.access !== 2 || isInactive} />
          </Form.Item>
        </Col>
      ),
    AddressNumber: () =>
      showField('AddressNumber') && (
        <Col span={3}>
          <Form.Item
            label="Número"
            name="addressNumber"
            rules={[
              {
                required: fieldsPermissions?.AddressNumber.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <InputNumber disabled={fieldsPermissions?.AddressNumber.access !== 2 || isInactive} />
          </Form.Item>
        </Col>
      ),
    District: () =>
      showField('District') && (
        <Col span={7}>
          <Form.Item
            label="Bairro"
            name="district"
            rules={[
              {
                required: fieldsPermissions?.District.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input disabled={fieldsPermissions?.District.access !== 2 || isInactive} />
          </Form.Item>
        </Col>
      ),
    Cep: () =>
      showField('Cep') && (
        <Col span={7}>
          <Form.Item
            label="CEP"
            name="cep"
            rules={[
              {
                required: fieldsPermissions?.Cep.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input
              id="cep"
              placeholder="00000-000"
              disabled={fieldsPermissions?.Cep.access !== 2 || isInactive}
            />
          </Form.Item>
        </Col>
      ),
    Complement: () =>
      showField('Complement') && (
        <Col span={8}>
          <Form.Item
            label="Complemento"
            name="complement"
            rules={[
              {
                required: fieldsPermissions?.Complement.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input disabled={fieldsPermissions?.Complement.access !== 2 || isInactive} />
          </Form.Item>
        </Col>
      ),
    City: () =>
      showField('City') && (
        <Col span={8}>
          <Form.Item
            label="Cidade"
            name="city"
            rules={[
              {
                required: fieldsPermissions?.City.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input disabled={fieldsPermissions?.City.access !== 2 || isInactive} />
          </Form.Item>
        </Col>
      ),
    State: () =>
      showField('State') && (
        <Col span={8}>
          <Form.Item
            label="Estado"
            name="state"
            rules={[
              {
                required: fieldsPermissions?.State.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input disabled={fieldsPermissions?.State.access !== 2 || isInactive} />
          </Form.Item>
        </Col>
      ),
    Email: () =>
      showField('Email') && (
        <Col span={8}>
          <Form.Item
            label="Email"
            name="email"
            rules={[
              {
                required: fieldsPermissions?.Email.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input
              placeholder="exemplo@email.com"
              disabled={fieldsPermissions?.Email.access !== 2 || isInactive}
            />
          </Form.Item>
        </Col>
      ),
    Phone1: () =>
      showField('Phone1') && (
        <Col span={8}>
          <Form.Item
            label="Telefone 1"
            name="phone1"
            rules={[
              {
                required: fieldsPermissions?.Phone1.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input
              id="phone1"
              placeholder="(00) 0000-0000"
              disabled={fieldsPermissions?.Phone1.access !== 2 || isInactive}
            />
          </Form.Item>
        </Col>
      ),
    Phone2: () =>
      showField('Phone2') && (
        <Col span={8}>
          <Form.Item
            label="Telefone 2"
            name="phone2"
            rules={[
              {
                required: fieldsPermissions?.Phone2.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input
              id="phone2"
              placeholder="(00) 0000-0000"
              disabled={fieldsPermissions?.Phone2.access !== 2 || isInactive}
            />
          </Form.Item>
        </Col>
      ),
    BitrixAddress: () =>
      showField('BitrixAddress') && (
        <Col span={8}>
          <Form.Item
            label="Endereço Bitrix"
            name="bitrixAddress"
            rules={[
              {
                required: fieldsPermissions?.BitrixAddress.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Select
              placeholder="Selecione"
              optionFilterProp="label"
              dropdownStyle={{ borderRadius: 16, zIndex: 9999 }}
              options={bitrixAddresses}
              showSearch
              disabled={fieldsPermissions?.BitrixAddress.access !== 2 || isInactive}
            />
          </Form.Item>
        </Col>
      ),
    MaxCapacityPerDay: () =>
      showField('MaxCapacityPerDay') && (
        <Col span={8}>
          <Form.Item
            label="Capacidade máx. de participantes por dia"
            name="maxCapacityPerDay"
            rules={[
              {
                required: fieldsPermissions?.MaxCapacityPerDay.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input disabled={fieldsPermissions?.MaxCapacityPerDay.access !== 2 || isInactive} />
          </Form.Item>
        </Col>
      ),
    WorkDays: () =>
      showField('WorkDays') && (
        <Col span={8}>
          <Form.Item
            label="Dias de funcionamento"
            name="workDays"
            rules={[
              {
                required: fieldsPermissions?.WorkDays.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Select
              options={workDaysOptions}
              mode="multiple"
              allowClear
              placeholder="Selecione"
              optionFilterProp="label"
              showSearch
              dropdownStyle={{ borderRadius: 16 }}
              maxTagCount="responsive"
              disabled={fieldsPermissions?.WorkDays.access !== 2 || isInactive}
              onChange={(values) =>
                Utils.handleSelectAllChange(values, workDaysOptions, 'workDays', form)
              }
            />
          </Form.Item>
        </Col>
      ),
    BusinessHour: () =>
      showField('BusinessHour') && (
        <Col span={8}>
          <Form.Item
            label="Horário de funcionamento"
            name="businessHour"
            rules={[
              {
                required: fieldsPermissions?.BusinessHour.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <TimePicker.RangePicker
              format="HH:mm"
              style={{ borderRadius: 16 }}
              disabled={fieldsPermissions?.BusinessHour.access !== 2 || loading || isInactive}
              ranges={{
                '08h às 18h': [
                  moment().startOf('day').add(8, 'hours'),
                  moment().startOf('day').add(18, 'hours'),
                ],
              }}
            />
          </Form.Item>
        </Col>
      ),
    BreakTime: () =>
      showField('BreakTime') && (
        <Col span={8}>
          <Form.Item
            label="Horário de intervalo"
            name="breakTime"
            rules={[
              {
                required: fieldsPermissions?.BreakTime.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <TimePicker.RangePicker
              format="HH:mm"
              style={{ borderRadius: 16 }}
              disabled={fieldsPermissions?.BreakTime.access !== 2 || loading || isInactive}
              ranges={{
                '12h às 13h': [
                  moment().startOf('day').add(12, 'hours'),
                  moment().startOf('day').add(13, 'hours'),
                ],
              }}
            />
          </Form.Item>
        </Col>
      ),
    TrainingKind: () =>
      showField('TrainingKind') && (
        <Col span={8}>
          <Form.Item
            label="Tipos de treinamento"
            name="trainingKind"
            rules={[
              {
                required: fieldsPermissions?.TrainingKind.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Select
              mode="multiple"
              allowClear
              placeholder="Selecione"
              optionFilterProp="label"
              showSearch
              options={trainingsOptions}
              dropdownStyle={{ borderRadius: 16 }}
              maxTagCount="responsive"
              disabled={fieldsPermissions?.TrainingKind.access !== 2 || isInactive}
              onChange={(values) =>
                Utils.handleSelectAllChange(values, trainingsOptions, 'trainingKind', form)
              }
            />
          </Form.Item>
        </Col>
      ),
    TracksKind: () =>
      showField('TracksKind') && (
        <Col span={8}>
          <Form.Item
            label="Tipos de pista"
            name="tracksKind"
            rules={[
              {
                required: fieldsPermissions?.TrainingKind.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Select
              mode="multiple"
              allowClear
              placeholder="Selecione"
              optionFilterProp="label"
              showSearch
              options={trainingsOptions}
              dropdownStyle={{ borderRadius: 16 }}
              maxTagCount="responsive"
              disabled={fieldsPermissions?.TracksKind.access !== 2 || isInactive}
              onChange={(values) =>
                Utils.handleSelectAllChange(values, trainingsOptions, 'tracksKind', form)
              }
            />
          </Form.Item>
        </Col>
      ),
    HasDiningHall: () =>
      showField('HasDiningHall') && (
        <Col span={2}>
          <Form.Item label="Refeitório" name="hasDiningHall" valuePropName="checked">
            <Checkbox disabled={fieldsPermissions?.HasDiningHall.access !== 2 || isInactive} />
          </Form.Item>
        </Col>
      ),
    HasFood: () =>
      showField('HasFood') && (
        <Col span={2.5}>
          <Form.Item label="Alimentação" name="hasFood" valuePropName="checked">
            <Checkbox disabled={fieldsPermissions?.HasFood.access !== 2 || isInactive} />
          </Form.Item>
        </Col>
      ),
    DiningHallCapacity: () =>
      showField('DiningHallCapacity') && (
        <Col span={4}>
          <Form.Item
            label="Capacidade Refeitório"
            name="diningHallCapacity"
            rules={[
              {
                required: fieldsPermissions?.DiningHallCapacity.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <InputNumber
              placeholder="0"
              min={0}
              disabled={fieldsPermissions?.DiningHallCapacity.access !== 2 || isInactive}
            />
          </Form.Item>
        </Col>
      ),
    HasLockerRoom: () =>
      showField('HasLockerRoom') && (
        <Col span={2}>
          <Form.Item label="Vestiários" name="hasLockerRoom" valuePropName="checked">
            <Checkbox disabled={fieldsPermissions?.HasLockerRoom.access !== 2 || isInactive} />
          </Form.Item>
        </Col>
      ),
    LockerRoomCapacity: () =>
      showField('LockerRoomCapacity') && (
        <Col span={4}>
          <Form.Item
            label="Capacidade Vestiários"
            name="lockerRoomCapacity"
            rules={[
              {
                required: fieldsPermissions?.LockerRoomCapacity.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <InputNumber
              placeholder="0"
              min={0}
              disabled={fieldsPermissions?.LockerRoomCapacity.access !== 2 || isInactive}
            />
          </Form.Item>
        </Col>
      ),
    HasClassRoom: () =>
      showField('HasClassRoom') && (
        <Col span={3}>
          <Form.Item label="Salas de aula" name="hasClassRoom" valuePropName="checked">
            <Checkbox disabled={fieldsPermissions?.HasClassRoom.access !== 2 || isInactive} />
          </Form.Item>
        </Col>
      ),
    ClassRoomsCapacity: () =>
      showField('ClassRoomsCapacity') && (
        <Col span={4}>
          <Form.Item
            label="Capacidade Salas"
            name="classRoomsCapacity"
            rules={[
              {
                required: fieldsPermissions?.ClassRoomsCapacity.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <InputNumber
              placeholder="0"
              min={0}
              disabled={fieldsPermissions?.ClassRoomsCapacity.access !== 2 || isInactive}
            />
          </Form.Item>
        </Col>
      ),
    CtQtyColumns: () =>
      showField('CtQtyColumns') && (
        <Col span={4}>
          <Form.Item
            name="ctQtyColumns"
            label="Qtd. Colunas"
            rules={[
              {
                required: fieldsPermissions?.CtQtyColumns.isRequired,
                message: 'Campo obrigatório!',
              },
              minZeroQtyRule,
            ]}
          >
            <InputNumber
              disabled={fieldsPermissions?.CtQtyColumns.access !== 2 || isInactive}
              placeholder="0"
              min={0}
              onChange={onResourceColumnsChange(setCtMaxSlots)}
            />
          </Form.Item>
        </Col>
      ),
    CtQtySlots: () =>
      showField('CtQtySlots') && (
        <Col span={4}>
          <Form.Item
            name="ctQtySlots"
            label="Qtd. Slots"
            dependencies={['ctQtyColumns']}
            rules={[
              {
                required: fieldsPermissions?.CtQtySlots.isRequired,
                message: 'Campo obrigatório!',
              },
              minZeroQtyRule,
              createSlotsCapRule('ctQtyColumns'),
            ]}
          >
            <InputNumber
              disabled={fieldsPermissions?.CtQtySlots.access !== 2 || isInactive}
              placeholder="0"
              min={0}
              max={ctMaxSlots}
              onChange={markResourceQtyModified}
            />
          </Form.Item>
        </Col>
      ),
    InCompanyQtyColumns: () =>
      showField('InCompanyQtyColumns') && (
        <Col span={4}>
          <Form.Item
            name="inCompanyQtyColumns"
            label="Qtd. Colunas"
            rules={[
              {
                required: fieldsPermissions?.InCompanyQtyColumns.isRequired,
                message: 'Campo obrigatório!',
              },
              minZeroQtyRule,
            ]}
          >
            <InputNumber
              disabled={fieldsPermissions?.InCompanyQtyColumns.access !== 2 || isInactive}
              placeholder="0"
              min={0}
              onChange={onResourceColumnsChange(setInCompanyMaxSlots)}
            />
          </Form.Item>
        </Col>
      ),
    InCompanyQtySlots: () =>
      showField('InCompanyQtySlots') && (
        <Col span={4}>
          <Form.Item
            name="inCompanyQtySlots"
            label="Qtd. Slots"
            dependencies={['inCompanyQtyColumns']}
            rules={[
              {
                required: fieldsPermissions?.InCompanyQtySlots.isRequired,
                message: 'Campo obrigatório!',
              },
              minZeroQtyRule,
              createSlotsCapRule('inCompanyQtyColumns'),
            ]}
          >
            <InputNumber
              disabled={fieldsPermissions?.InCompanyQtySlots.access !== 2 || isInactive}
              placeholder="0"
              min={0}
              max={inCompanyMaxSlots}
              onChange={markResourceQtyModified}
            />
          </Form.Item>
        </Col>
      ),
    EadQtyColumns: () =>
      showField('EadQtyColumns') && (
        <Col span={4}>
          <Form.Item
            name="eadQtyColumns"
            label="Qtd. Colunas"
            rules={[
              {
                required: fieldsPermissions?.EadQtyColumns.isRequired,
                message: 'Campo obrigatório!',
              },
              minZeroQtyRule,
            ]}
          >
            <InputNumber
              disabled={fieldsPermissions?.EadQtyColumns.access !== 2 || isInactive}
              placeholder="0"
              min={0}
              onChange={onResourceColumnsChange(setEadMaxSlots)}
            />
          </Form.Item>
        </Col>
      ),
    EadQtySlots: () =>
      showField('EadQtySlots') && (
        <Col span={4}>
          <Form.Item
            name="eadQtySlots"
            label="Qtd. Slots"
            dependencies={['eadQtyColumns']}
            rules={[
              {
                required: fieldsPermissions?.EadQtySlots.isRequired,
                message: 'Campo obrigatório!',
              },
              minZeroQtyRule,
              createSlotsCapRule('eadQtyColumns'),
            ]}
          >
            <InputNumber
              disabled={fieldsPermissions?.EadQtySlots.access !== 2 || isInactive}
              placeholder="0"
              min={0}
              max={eadMaxSlots}
              onChange={markResourceQtyModified}
            />
          </Form.Item>
        </Col>
      ),
    ServiceQtyColumns: () =>
      showField('ServiceQtyColumns') && (
        <Col span={4}>
          <Form.Item
            name="serviceQtyColumns"
            label="Qtd. Colunas"
            rules={[
              {
                required: fieldsPermissions?.ServiceQtyColumns.isRequired,
                message: 'Campo obrigatório!',
              },
              minZeroQtyRule,
            ]}
          >
            <InputNumber
              disabled={fieldsPermissions?.ServiceQtyColumns.access !== 2 || isInactive}
              placeholder="0"
              min={0}
              onChange={onResourceColumnsChange(setServiceMaxSlots)}
            />
          </Form.Item>
        </Col>
      ),
    ServiceQtySlots: () =>
      showField('ServiceQtySlots') && (
        <Col span={4}>
          <Form.Item
            name="serviceQtySlots"
            label="Qtd. Slots"
            dependencies={['serviceQtyColumns']}
            rules={[
              {
                required: fieldsPermissions?.ServiceQtySlots.isRequired,
                message: 'Campo obrigatório!',
              },
              minZeroQtyRule,
              createSlotsCapRule('serviceQtyColumns'),
            ]}
          >
            <InputNumber
              disabled={fieldsPermissions?.ServiceQtySlots.access !== 2 || isInactive}
              placeholder="0"
              min={0}
              max={serviceMaxSlots}
              onChange={markResourceQtyModified}
            />
          </Form.Item>
        </Col>
      ),
  };

  return (
    <Form
      form={form}
      disabled={loading || isInactive}
      name="TrainingCenterRegister"
      onFinish={submit}
      layout="vertical"
      autoComplete="off"
      onChange={() => setScreenModified(true)}
    >
      <div className="form-toolbar">
        {screenModified && (
          <Popconfirm
            title="Deseja mesmo voltar?"
            onConfirm={() => navigate(-1)}
            okText="Sim"
            cancelText="Não"
          >
            <Button>Voltar</Button>
          </Popconfirm>
        )}
        {!screenModified && <Button onClick={() => navigate(-1)}>Voltar</Button>}
        <Button loading={loading} block type="primary" htmlType="submit">
          Salvar
        </Button>
      </div>

      {/* Campos invisiveis */}
      <Form.Item className="input-hidden" label="Id" name="id">
        <Input />
      </Form.Item>
      <RegisterLayoutBody
        fieldLayout={fieldLayout}
        fieldsPermissions={fieldsPermissions}
        roleId={roleId}
        widgetMap={widgetMap}
        form={form}
        loading={loading}
        extraFields={<Tabs>{extraTabPanes()}</Tabs>}
        padraoFields={
          <Tabs>
            <Tabs.TabPane tab="Dados Gerais" key="generalData">
              <Row gutter={[24]}>
                {widgetMap.Cnpj()}

                {widgetMap.Name()}

                {widgetMap.CommercialName()}

                {widgetMap.Street()}

                {widgetMap.AddressNumber()}

                {widgetMap.District()}

                {widgetMap.Cep()}

                {widgetMap.Complement()}

                {widgetMap.City()}

                {widgetMap.State()}

                {widgetMap.Email()}

                {widgetMap.Phone1()}

                {widgetMap.Phone2()}
              </Row>
            </Tabs.TabPane>
            <Tabs.TabPane tab="Dados Complementares" key="additionalData" forceRender>
              <Row gutter={[24]}>
                {widgetMap.BitrixAddress()}

                {widgetMap.MaxCapacityPerDay()}

                {widgetMap.WorkDays()}

                {widgetMap.BusinessHour()}
                {widgetMap.BreakTime()}

                {widgetMap.TrainingKind()}

                {widgetMap.TracksKind()}

                {widgetMap.HasDiningHall()}

                {widgetMap.HasFood()}

                {widgetMap.DiningHallCapacity()}

                {widgetMap.HasLockerRoom()}

                {widgetMap.LockerRoomCapacity()}

                {widgetMap.HasClassRoom()}

                {widgetMap.ClassRoomsCapacity()}
              </Row>
            </Tabs.TabPane>
            <Tabs.TabPane tab="Recursos" key="resourcesData" forceRender>
              <Row gutter={[24]}>
                {(showField('CtQtyColumns') || showField('CtQtySlots')) && (
                  <Col span={24}>
                    <Divider className="configuration-divider" orientation="left">
                      CT
                    </Divider>
                  </Col>
                )}

                {widgetMap.CtQtyColumns()}

                {widgetMap.CtQtySlots()}

                {(showField('InCompanyQtyColumns') || showField('InCompanyQtySlots')) && (
                  <Col span={24}>
                    <Divider className="configuration-divider" orientation="left">
                      In Company
                    </Divider>
                  </Col>
                )}

                {widgetMap.InCompanyQtyColumns()}

                {widgetMap.InCompanyQtySlots()}

                {(showField('EadQtyColumns') || showField('EadQtySlots')) && (
                  <Col span={24}>
                    <Divider className="configuration-divider" orientation="left">
                      EAD
                    </Divider>
                  </Col>
                )}

                {widgetMap.EadQtyColumns()}

                {widgetMap.EadQtySlots()}

                {(showField('ServiceQtyColumns') || showField('ServiceQtySlots')) && (
                  <Col span={24}>
                    <Divider className="configuration-divider" orientation="left">
                      Serviço
                    </Divider>
                  </Col>
                )}

                {widgetMap.ServiceQtyColumns()}

                {widgetMap.ServiceQtySlots()}
              </Row>
            </Tabs.TabPane>
            {extraTabPanes()}
          </Tabs>
        }
      />
    </Form>
  );
}

const TrainingCenterRegister = memo(TrainingCenterRegisterComponent);
export default TrainingCenterRegister;
